import { useNavLinks } from "./hooks";
import NavigationLinks from "./NavigationLinks";

const NavigationLinksContainer: React.FC = () => {
  const { navLinks } = useNavLinks();
  return <NavigationLinks navigationLinks={navLinks} />;
};

export default NavigationLinksContainer;
